import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=859d3c62&scoped=true&lang=pug&"
import script from "./faq.vue?vue&type=script&lang=js&"
export * from "./faq.vue?vue&type=script&lang=js&"
import style0 from "./faq.vue?vue&type=style&index=0&id=859d3c62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859d3c62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('859d3c62')) {
      api.createRecord('859d3c62', component.options)
    } else {
      api.reload('859d3c62', component.options)
    }
    module.hot.accept("./faq.vue?vue&type=template&id=859d3c62&scoped=true&lang=pug&", function () {
      api.rerender('859d3c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/faq.vue"
export default component.exports